import { render, staticRenderFns } from "./technological-area.vue?vue&type=template&id=940c10ae&scoped=true"
import script from "./technological-area.vue?vue&type=script&lang=js"
export * from "./technological-area.vue?vue&type=script&lang=js"
import style0 from "./technological-area.vue?vue&type=style&index=0&id=940c10ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940c10ae",
  null
  
)

export default component.exports